import {ROOT_URL} from '../../config';
import request from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {
    fetchedUser,
    fetchedUserRoles,
    updatedUserRoles,
    fetchedUserSites,
    fetchedUserLanguages,
    fetchedPermissionsGrouped,
    fetchedUserPermissions
} from './actions';

export function fetchUser(id) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/users/${id}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedUser(response.data)));
    }
}

export function fetchUserRoles(userId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/users/${userId}/roles`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedUserRoles(response.data)));
    }
}

export function fetchUserSites(userId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/users/${userId}/sites`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedUserSites(response.data)));
    }
}

export function fetchUserLanguages(userId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/users/${userId}/languages`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedUserLanguages(response.data)));
    }
}

export function updateUserRoles(data) {
    return (dispatch) => {

        let userRolesToUpdate = {};
        
        function getArrays(updateArray){
            let updateDataArray = [];
            Object.entries(updateArray).forEach(([index, item]) => {
                let itemId = item.value;
                updateDataArray.push(itemId)
            })

            return updateDataArray;
        }

        Object.entries(data).forEach(([key, dataArray]) => {
            if (typeof dataArray === 'object') {
                userRolesToUpdate[key] = getArrays(dataArray);
            }
        });

        let options = {
            url: `${ROOT_URL}/users/${data.id}`,
            method: 'PUT',
            data: userRolesToUpdate
        };

        return request(options, dispatch)
            .then(response => dispatch(updatedUserRoles(data)))
            .then(() => toastr.success('Success!', 'User roles, sites and languages have been updated.'));
    };
}

export function fetchPermissionsGrouped() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/permissions-grouped?_onlyChildren=1`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedPermissionsGrouped(response.data)));
    }
}

export function fetchUserPermissions(userId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/users/${userId}/permissions?_grouped=grouped`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedUserPermissions(response.data)));
    }
}


// WEBPACK FOOTER //
// ./src/containers/users/thunks.js